import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { store } from "../src/Redux/store";
import { Provider } from "react-redux";
import './i18n';

import LoadingOverlay from "react-loading-overlay-ts"; 

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <Suspense
        fallback={
          <div className="wrap">
            <LoadingOverlay className="loader" active={true} spinner>
              <div className="wrap-layout" />
            </LoadingOverlay>
          </div>
        }
      >
        <App />
      </Suspense>
    </Provider>
  </BrowserRouter>
);

reportWebVitals();
